import { createAction } from "redux-actions";

import { IClientPatch, IPatchAction } from "../../../components/course-author/helpers/patches";
import { PreferredLocale } from "../../../utils/locales";
import { IScormPackage } from "../../types/common";

export interface IInitialData {
  courseName: string;
  scormPackage: IScormPackage;
  memberIds: string[];
}

export enum Action {
  FETCH_INITIAL_DATA = "SCORM_PACKAGE_MANAGEMENT/FETCH_INITIAL_DATA",
  HANDLE_FETCH_INITIAL_DATA_SUCCESS = "SCORM_PACKAGE_MANAGEMENT/HANDLE_FETCH_INITIAL_DATA_SUCCESS",
  HANDLE_FETCH_INITIAL_DATA_FAILURE = "SCORM_PACKAGE_MANAGEMENT/HANDLE_FETCH_INITIAL_DATA_FAILURE",
  PATCH_SCORM_PACKAGE = "SCORM_PACKAGE_MANAGEMENT/PATCH_SCORM_PACKAGE",
  HANDLE_PATCH_SCORM_PACKAGE_SUCCESS = "SCORM_PACKAGE_MANAGEMENT/HANDLE_PATCH_SCORM_PACKAGE_SUCCESS",
  HANDLE_PATCH_SCORM_PACKAGE_FAILURE = "SCORM_PACKAGE_MANAGEMENT/HANDLE_PATCH_SCORM_PACKAGE_FAILURE",
  HANDLE_REFRESH_SCORM_PACKAGE_SUCCESS = "SCORM_PACKAGE_MANAGEMENT/HANDLE_REFRESH_SCORM_PACKAGE_SUCCESS",
  HANDLE_REFRESH_SCORM_PACKAGE_FAILURE = "SCORM_PACKAGE_MANAGEMENT/HANDLE_REFRESH_SCORM_PACKAGE_FAILURE",
  SET_CURRENT_LOCALE = "SCORM_PACKAGE_MANAGEMENT/SET_CURRENT_LOCALE",
  MOUNT = "SCORM_PACKAGE_MANAGEMENT/MOUNT",
  UNMOUNT = "SCORM_PACKAGE_MANAGEMENT/UNMOUNT",
}

export const handleFetchInitialDataSuccess = createAction<IInitialData>(Action.HANDLE_FETCH_INITIAL_DATA_SUCCESS);
export const handleFetchInitialDataFailure = createAction<{ message: string }>(
  Action.HANDLE_FETCH_INITIAL_DATA_FAILURE
);
export const mount = createAction<string>(Action.MOUNT);
export const unmount = createAction<void>(Action.UNMOUNT);
export const patchScormPackage = createAction<IClientPatch<IPatchAction>>(Action.PATCH_SCORM_PACKAGE);
export const handlePatchScormPackageSuccess = createAction<void>(Action.HANDLE_PATCH_SCORM_PACKAGE_SUCCESS);
export const handlePatchScormPackageFailure = createAction<{ message: string }>(
  Action.HANDLE_PATCH_SCORM_PACKAGE_FAILURE
);
export const handleRefreshScormPackageSuccess = createAction<IScormPackage>(
  Action.HANDLE_REFRESH_SCORM_PACKAGE_SUCCESS
);
export const handleRefreshScormPackageFailure = createAction<{
  message: string;
}>(Action.HANDLE_REFRESH_SCORM_PACKAGE_FAILURE);
export const setCurrentLocale = createAction<PreferredLocale>(Action.SET_CURRENT_LOCALE);
